import React from "react";
import AdjustmentBreadCrumb from "../../Components/Adjustment/AdjustmentBreadCrumb";
import AdjustmentListings from "../../Components/Adjustment/AdjustmentListings";

export default function AdjustmentListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <AdjustmentBreadCrumb />
        <AdjustmentListings />
      </div>
    </React.Fragment>
  );
}
